Notifications.$inject = [
    'Backoffice',
    'Echo',
    'Club',
    'User',
    '$rootScope',
    'NotificationFactory',
];

/* @ngInject */
function Notifications(
    Backoffice,
    Echo,
    Club,
    User,
    $rootScope,
    NotificationFactory,
) {
    var service = this;
    var Channels;

    service.activate = function () {
        // Reboot Echo server on reconnect
        Echo.reconnect();
        Channels.club.activate();
    };
    service.deactivate = function () {
        Channels.club.deactivate();
    };

    /**
     * Channels
     * @type {Object}
     * @singleton
     */
    Channels = {
        club: {
            channel: null,
            activate: function () {
                var club = Channels.club;
                if (club.channel) {
                    return;
                }
                // Subscribe to default channels
                club.channel = Echo.private('club.' + Club.id);
                // Hook event Handlers
                // club.channel.listen(Echo.defaultChannel, eventHandler);
                // Push desde notifier
                club.channel.listen('.NotifierPushNotifications', (e) => {
                    eventHandler(e.metadata);
                });
            },
            deactivate: function () {
                var club = Channels.club;
                Echo.leave('club.' + Club.id);
                club.channel.unbind();
                club.channel = null;
            },
        },
    };

    function eventHandler(payload) {
        const lastAction = JSON.parse(
            localStorage.getItem('lastAction') || '{}',
        );
        var notification = NotificationFactory.create(payload);

        if (lastAction?.tabId !== $rootScope.tabId) {
            console.log('tabId', $rootScope.tabId);

            switch (payload.action) {
                case 'new_online': {
                    Backoffice.api.registerEvent(
                        'online-booking-created',
                        payload,
                    );
                    break;
                }
                case 'cancel_online': {
                    Backoffice.api.registerEvent(
                        'online-booking-cancelled',
                        payload,
                    );
                    break;
                }
                case 'new_local': {
                    Backoffice.api.registerEvent(
                        'local-booking-created',
                        payload,
                    );
                    break;
                }
                case 'cancel_local': {
                    Backoffice.api.registerEvent(
                        'local-booking-cancelled',
                        payload,
                    );
                    break;
                }
                case 'done': {
                    Backoffice.api.registerEvent('booking-done', payload);
                    break;
                }
                default: {
                    break;
                }
            }
        }

        $rootScope.$broadcast('booking:notification', notification);
        $rootScope.$broadcast(
            'booking:court:' + notification.data.court.id,
            notification,
        );
        $rootScope.$broadcast('booking:id:' + notification.id, notification);

        if (User.data.id === notification.uid()) {
            return;
        }

        if (notification.isToast) {
            notification.toastr();
        }
        if (notification.isDesktop) {
            notification.desktop();
        }
    }
}

export default Notifications;
